import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import AOS from "aos";
import "aos/dist/aos.css";

import HeroBanner from "./HeroBanner";
import AboutApexo from "./AboutApexo";
import IndustryServe from "./IndustryServe";
import Contactus from "./Contact";

function Apexoindustrial() {

  useEffect(() => {

    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
      offset: 80,
    });

    AOS.refresh();

  }, []);

  return (
    <>

      {/* ================= SEO ================= */}

      <Helmet>

        <title>
          Apexo Industrial | Industrial Chemicals, Yeast & Enzymes Supplier
        </title>

        <meta
          name="description"
          content="Apexo Industrial is a trusted supplier of Industrial Chemicals, Distillery Yeast, Enzymes and Process Solutions for Sugar, Distillery and Process Industries across India."
        />

        <meta
          name="keywords"
          content="Industrial Chemicals, Distillery Chemicals, Yeast, Enzymes, Sugar Industry Chemicals, Distillery Solutions, Apexo Industrial"
        />

        <meta property="og:title" content="Apexo Industrial" />

        <meta
          property="og:description"
          content="Leading supplier of Industrial Chemicals, Yeast and Enzymes for Sugar & Distillery Industries."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://apexoindustrial.com/"
        />

        <link
          rel="canonical"
          href="https://apexoindustrial.com/"
        />

      </Helmet>

      {/* ================= HERO ================= */}

      <section
        id="home"
        data-aos="fade-up"
      >
        <HeroBanner />
      </section>

      {/* ================= ABOUT ================= */}

      <section
        id="about"
        data-aos="fade-right"
      >
        <AboutApexo />
      </section>

      {/* ================= PRODUCTS ================= */}

      <section
        id="products"
        data-aos="fade-left"
      >
        <IndustryServe />
      </section>

      {/* ================= CONTACT ================= */}

      <section
        id="contact"
        data-aos="zoom-in"
      >
        <Contactus />
      </section>

    </>
  );
}

export default Apexoindustrial;